import React, { useCallback, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { asArray } from '../page/utils'

const CloseIcon = () => (
	<FontAwesomeIcon icon={["fas", "times"]} color='#FFF' size='sm' />
)

// const CheckIcon = () => (
// 	<FontAwesomeIcon icon={["fas", "check"]} color='#FFF' size='sm' />
// )

const TaskIcon = () => (
	<FontAwesomeIcon icon={["fas", "spinner"]} color='#17a2b8' size='lg' spin className='m-2' />
)
const ErrorIcon = () => (
	<FontAwesomeIcon icon={["fas", "exclamation-triangle"]} color='#dc3545' size='lg' className='m-2' />
)

const InfoIcon = () => (
	<FontAwesomeIcon icon={["fas", "info-circle"]} color='#17a2b8' size='lg' className='m-2' />
)

const SuccessIcon = () => (
	<FontAwesomeIcon icon={["fas", "check-circle"]} color='#28a745' size='lg' className='m-2' />
)

const alertStyle = {
	backgroundColor: '#151515',
	color: 'white',
	padding: '10px',
	borderRadius: '3px',
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	boxShadow: '0px 2px 2px 2px rgba(0, 0, 0, 0.03)',
	fontFamily: 'Arial',
	width: '300px',
	boxSizing: 'border-box'
}

const buttonStyle = {
	marginLeft: '20px',
	border: 'none',
	backgroundColor: 'transparent',
	cursor: 'pointer',
	color: '#FFFFFF'
}

const secondsToTime = seconds => {
	const mm = String(Math.floor(seconds / 60)).padStart(2, "0")
	const ss = String(Math.floor(seconds % 60)).padStart(2, "0")

	return `${mm}:${ss}`
}

const TaskEventTemplate = ({ message, options, style, close }) => {
	const [{ status, closing, seconds }, _setStatus] = useState({ status: "task", closing: false, start: Date.now(), seconds: 0 })
	const { resultPromise, detail } = options;

	const setClosing = useCallback(() => _setStatus(prev => ({ ...prev, closing: true })), [])
	const setStatus = useCallback(status => _setStatus(prev => ({ ...prev, status })), [])
	const setSeconds = useCallback(now => _setStatus(prev => ({ ...prev, seconds: parseInt((now - prev.start) / 1000) })), [])

	useEffect(() => {
		const interval = setInterval(() => {
			setSeconds(Date.now())
		}, 1000)

		return () => clearInterval(interval);
	}, [setSeconds])

	useEffect(() => {
		if (closing) return;

		const closeCall = () => {
			setClosing();
			close();
		}

		if (status === "close") {
			closeCall()
		} else if (status === "success") {
			setTimeout(closeCall, 1500)
		}
	}, [status, closing, close, setClosing])

	useEffect(() => {
		if (resultPromise instanceof Promise) {
			resultPromise.then(status => setStatus(status))
		}
	}, [resultPromise, setStatus])

	return (
		<div style={{ ...alertStyle, ...style, marginTop: "1px" }}>
			{
				status === 'success'
					? <SuccessIcon />
					: status === 'error'
						? <ErrorIcon />
						: <TaskIcon />
			}
			<div className='flex-grow-1'>
				<span className='d-block text-truncate'>{message}</span>
				{asArray(detail || []).filter(e => !!e).map(msg => <span className='d-block text-light font-weight-light font-italic' style={{ fontSize: 'small' }}>{msg}</span>)}
			</div>
			<span className='d-block flex-grow-0 align-self-end text-secondary text-right' style={{ fontSize: 'x-small', fontFamily: "monospace" }} >{secondsToTime(seconds)}</span>



			{status === "success" || status === "error"
				? (
					<button onClick={close} style={buttonStyle}>
						<CloseIcon />
					</button>
				)
				: null
			}
		</div>
	)
}

const EventTemplate = (props) => {
	const eventType = props.options.type

	if (eventType === "task") return <TaskEventTemplate {...props} />

	const { style, message, close } = props;
	return (
		<div style={{ ...alertStyle, ...style, marginTop: "1px" }}>
			{eventType === 'task' && <TaskIcon />}
			{eventType === 'info' && <InfoIcon />}
			{eventType === 'success' && <SuccessIcon />}
			{eventType === 'error' && <ErrorIcon />}
			<span style={{ flex: 2 }}>{message}</span>
			<button onClick={close} style={buttonStyle}>
				<CloseIcon />
			</button>
		</div>
	)
}

export default EventTemplate